const VAT = 1.22;

export default function calculateSaving(propertyValue: number, fee: number, minWithoutVat: number = 0) {
  return (Math.max(minWithoutVat, (propertyValue * fee) / 100) * VAT);
}
